import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "header__burger d-none-xl"
}
const _hoisted_3 = { class: "click-wrapper" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "burger__bar" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "burger__bar" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "burger__bar" }, null, -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "burger-menu__content" }
const _hoisted_10 = { class: "mobile-nav" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "header__logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header__img",
    src: "/static/app/header-logo.svg",
    alt: "header-logo"
  })
], -1)
const _hoisted_13 = {
  key: 1,
  class: "g-row g-row--appearance_spaced g-row--align_center g-row--space_2xl g-row--justify_between menu-wrapper d-none-till-xl"
}
const _hoisted_14 = { class: "g-cell g-cols g-cols--narrow-xs" }
const _hoisted_15 = { class: "main-nav" }
const _hoisted_16 = { class: "g-cell g-cols g-cols--narrow-xs" }
const _hoisted_17 = { class: "main-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_click_outside = _resolveComponent("ui-click-outside")!
  const _component_sidebar_trigger = _resolveComponent("sidebar-trigger")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_sidebar_trigger, { "input-ref": _ctx.$emit }, {
            default: _withCtx(({ sidebarIsOpen, sidebarToggle, sidebarClose }) => [
              _createVNode(_component_ui_click_outside, { do: sidebarClose }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["burger", {'is-active': sidebarIsOpen}]),
                        onClick: _withModifiers(sidebarToggle, ["prevent"])
                      }, _hoisted_8, 10, _hoisted_4),
                      _createVNode(_Transition, { name: "slide" }, {
                        default: _withCtx(() => [
                          sidebarIsOpen
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["burger-menu", { "is-active": sidebarIsOpen }])
                              }, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("nav", _hoisted_10, [
                                    ($setup.isAuthenticated)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "mobile-nav__item mobile-nav__item--logout",
                                          onClick: _withModifiers(($event: any) => (sidebarToggle, $setup.logoutUser()), ["prevent"])
                                        }, _toDisplayString(_ctx.$t('Logout')), 9, _hoisted_11))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 2))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["do"])
            ]),
            _: 1
          }, 8, ["input-ref"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_12,
    ($setup.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("nav", _hoisted_15, [
              _createVNode(_component_router_link, {
                class: "main-nav__item",
                to: { name: $setup.DOMAINS_PAGE_NAME }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Domains')), 1)
                ]),
                _: 1
              }, 8, ["to"]),
              _createVNode(_component_router_link, {
                class: "main-nav__item",
                to: { name: $setup.BUYERS_PAGE_NAME }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Buyers')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("nav", _hoisted_17, [
              _createElementVNode("div", {
                class: "main-nav__item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.logoutUser()))
              }, _toDisplayString(_ctx.$t('Logout')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}